module.exports = __webpack_public_path__ + "img/2.8c7326a1.jpg";